// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationResultSearchBase } from './priorAuthorizationResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationResultSearchResponse {
    'results': Array<PriorAuthorizationResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<PriorAuthorizationResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationResultSearchResponse.attributeTypeMap;
    }
}
